export const translations = {
  fr: {
    nav: {
      varieties: "Nos Cafés",
      origin: "Origine Sierra",
      b2b: "Offre Coffee Shops",
      process: "Processus",
      contact: "Contact",
      cta: "Coffret Échantillon B2B",
      login: "Connexion",
      logout: "Déconnexion",
    },
    auth: {
      modalTitle: "Votre compte Monte Yolli",
      nameLabel: "Nom complet",
      emailLabel: "Email",
      passwordLabel: "Mot de passe (8 caractères min.)",
      submitIn: "Se connecter",
      submitUp: "Créer mon compte",
      switchToUp: "Pas encore de compte ? Créez-en un",
      switchToIn: "Déjà inscrit ? Connectez-vous",
      orGoogle: "Continuer avec Google",
      mySpace: "Mon espace",
      myRequests: "Mes demandes B2B",
      noRequests: "Aucune demande envoyée pour le moment.",
      welcomeToast: "Bienvenue chez Monte Yolli",
      errorGeneric: "Une erreur est survenue. Réessayez.",
    },
    chat: {
      openLabel: "Conseiller",
      title: "Conseiller Monte Yolli",
      subtitle: "IA — FR / ES / EN",
      welcome: "Bonjour ! Je suis le conseiller Monte Yolli. Quelle variété cherchez-vous, ou de quel volume votre coffee shop a-t-il besoin ?",
      placeholder: "Écrivez votre question…",
      error: "Le conseiller est momentanément indisponible. Réessayez.",
    },
    journal: {
      eyebrow: "Journal",
      titleA: "Le journal de",
      titleEm: "la Sierra",
      sub: "Histoires d'altitude, récoltes et culture du café — rédigés par notre équipe et notre conseiller IA.",
      read: "Lire l'article",
      close: "Réduire",
    },
    estimate: {
      title: "Assistant IA — Estimation B2B",
      placeholder: "Décrivez votre établissement (ex : café de quartier, 2 machines espresso, 300 tasses/jour)…",
      button: "Analyser mes besoins",
      analyzing: "Analyse en cours…",
      error: "L'assistant est indisponible. Réessayez.",
    },
    admin: {
      link: "Espace Admin",
      title: "Espace Admin",
      tabRequests: "Demandes B2B",
      tabArticles: "Générateur d'articles",
      topicPlaceholder: "Sujet de l'article (ex : la récolte 2026 dans la Sierra)…",
      generate: "Générer l'article",
      generating: "Rédaction en cours…",
      published: "Article publié sur le site",
      deleteLabel: "Supprimer",
      noArticles: "Aucun article pour le moment.",
      restricted: "Accès réservé à l'administrateur.",
      notLoggedIn: "Connectez-vous avec le compte administrateur.",
      backHome: "Retour au site",
      emptyRequests: "Aucune demande reçue pour le moment.",
      colDate: "Date",
      colBusiness: "Établissement",
      colContact: "Contact",
      colVolume: "Volume",
      colVarieties: "Variétés",
      colMessage: "Message",
      colSample: "Coffret",
      tabConfig: "Configuration",
      saveLabel: "Enregistrer",
      settingsSaved: "Paramètres enregistrés",
      contactEmailLabel: "Email de contact du site",
      contactPhoneLabel: "Téléphone du site",
      contactWebsiteLabel: "Site web affiché",
      notifEmailLabel: "Email de réception des commandes",
      refresh: "Rafraîchir",
      loadError: "Impossible de charger les demandes. Touchez Rafraîchir.",
      labelBtn: "Étiquette",
      printLabel: "Imprimer l'étiquette d'expédition",
      fromLabel: "Expéditeur",
      toLabel: "Destinataire",
      resetBox: "Réinitialiser la boîte",
      resetConfirm: "Supprimer définitivement TOUTES les demandes de la boîte de commandes ? Cette action est irréversible.",
      resetDone: "Boîte de commandes réinitialisée",
      deleteRequest: "Supprimer cette demande",
      deleteConfirm: "Supprimer cette demande ?",
      requestDeleted: "Demande supprimée",
      diagLine: "Base « {db} » · {n} demande(s) enregistrée(s) · dernière : {last}",
      diagNone: "aucune",
      liveHint: "Les commandes envoyées sur le site en ligne apparaissent uniquement dans l'admin du site en ligne (base séparée de l'aperçu).",
      maintenanceLabel: "Site en attente (page « Bientôt »)",
      maintenanceHelp: "Coché : les visiteurs voient une page d'attente élégante avec vos coordonnées. Décoché : le site complet est visible. L'admin reste toujours accessible via /admin.",
      maintenanceOn: "Actuellement : site en attente — les visiteurs voient la page « Bientôt »",
      maintenanceOff: "Actuellement : site complet visible par tous",
    },
    maintenance: {
      badge: "Del Corazón de la Montaña — 1 850 m",
      title: "Notre nouveau site arrive",
      titleEm: "bientôt.",
      text: "Monte Yolli prépare sa nouvelle vitrine en ligne. Pour toute commande de café de spécialité — Geisha, Gourmet, Lavado, Honey — ou pour un coffret échantillon coffee shop, contactez-nous directement.",
    },
    fields: {
      address: "Adresse complète (numéro et rue)",
      city: "Ville",
      postal: "Code postal",
      country: "Pays",
    },
    hero: {
      badge: "Del Corazón de la Montaña — 1 850m",
      line1: "CAFÉ DE LA",
      line2Em: "SIERRA",
      line2Post: "MEXICAINE",
      line3: "DU CŒUR DE LA MONTAÑA",
      sub: "Monte Yolli cultive quatre variétés d'exception — Geisha, Gourmet, Lavado et Honey — en haute altitude de la Sierra mexicaine. De la Sierra à votre table, et des montagnes à votre comptoir.",
      ctaVarieties: "Découvrir nos cafés",
      ctaB2b: "Espace Distributeur B2B",
      location: "Tulancingo, Hidalgo — Mexique",
      altitudeLabel: "Altitude de culture — Sierra MX",
      chip: "Sac 400g — Micro Lote",
    },
    marquee: [
      "Café de la Sierra",
      "Del Corazón de la Montaña",
      "1 850m d'Altitude",
      "Geisha",
      "Gourmet",
      "Lavado",
      "Honey",
      "Micro Lote — Sac 400g",
      "Distribution pour Coffee Shops",
      "De la Sierra a tu Mesa",
    ],
    products: {
      eyebrow: "Nos Produits",
      titleA: "Le sac Monte Yolli,",
      titleEm: "quatre signatures",
      sub: "Chaque variété est cultivée en haute altitude, traitée selon sa méthode idéale et torréfiée à la commande pour révéler sa signature aromatique.",
      spotEyebrow: "Le Produit",
      spotTitle: "Sac Monte Yolli",
      spotDesc: "L'étiquette aux couleurs de l'art populaire mexicain abrite un café d'origine en micro-lot : torréfié et moulu à la commande, prêt pour votre cafetière comme pour votre machine espresso professionnelle.",
      specs: [
        ["Contenu net", "400g"],
        ["Type", "Café de Origen — Micro Lote"],
        ["Torréfaction", "Tostado y Molido, à la commande"],
        ["Origine", "Hecho en Tulancingo, México"],
      ],
      ctaDevis: "Demander un devis",
      lineupEyebrow: "Distribution",
      lineupTitle: "Format 400g — cartons de 10 unités",
      labels: { altitude: "Altitude", process: "Procédé", roast: "Torréfaction" },
    },
    varieties: [
      {
        id: "geisha",
        name: "GEISHA",
        tag: "L'Excellence Rare",
        altitude: "1 950m",
        process: "Honey Supérieur",
        notes: ["Jasmin", "Bergamote", "Pêche Blanche", "Miel Sauvage"],
        roast: "Légère / Filtre & Slow Coffee",
        score: "89.5 SCA",
        description: "Un profil floral aérien et complexe aux notes rares de fleur d'oranger et de miel de montagne, réservé aux établissements d'exception.",
      },
      {
        id: "gourmet",
        name: "GOURMET",
        tag: "Le Grand Classique Structuré",
        altitude: "1 750m",
        process: "Lavé Traditionnel",
        notes: ["Chocolat Noir 72%", "Noisette Grillée", "Cacao Brut", "Caramel Chaud"],
        roast: "Moyenne / Espresso & Cappuccino",
        score: "86.5 SCA",
        description: "Un corps rond, velouté et gourmand. L'équilibre parfait pour les boissons à base de lait et les espressos intenses.",
      },
      {
        id: "lavado",
        name: "LAVADO",
        tag: "La Pureté Minérale",
        altitude: "1 800m",
        process: "Double Lavage à l'Eau de Source",
        notes: ["Agrumes Doux", "Pomme Verte", "Canne à Sucre", "Thé Noir"],
        roast: "Moyenne-Légère / Espresso Polyvalent",
        score: "87.0 SCA",
        description: "Une acidité vive et cristalline issue d'un lavage méticuleux à l'eau pure des sources de la Sierra.",
      },
      {
        id: "honey",
        name: "HONEY",
        tag: "L'Onctuosité Fruitée",
        altitude: "1 850m",
        process: "Yellow Honey Sensation",
        notes: ["Papaye", "Prune Séchée", "Sucre Muscovado", "Vanille de Papantla"],
        roast: "Moyenne / Polyvalent Espresso & Filtre",
        score: "88.0 SCA",
        description: "Séché avec sa pulpe naturelle au soleil mexicain, offrant une douceur sucrée incomparable et une texture sirupeuse.",
      },
    ],
    origin: {
      eyebrow: "Origine — Sierra Madre",
      titleA: "La montagne écrit",
      titleEm: "le goût",
      text: "Au cœur des montagnes du Mexique, nos parcelles s'accrochent aux pentes de la Sierra, entre 1 600 et 2 100 mètres d'altitude. Là-haut, le grain mûrit lentement, sous la brume, et gagne une densité aromatique qu'aucune plaine ne peut imiter.",
      factors: [
        { title: "Ombre Naturelle", text: "Les caféiers poussent sous la canopée brumeuse de la forêt d'altitude." },
        { title: "Sol Volcanique", text: "Un terroir minéral riche qui forge la complexité de chaque grain." },
        { title: "Récolte 100% Manuelle", text: "Cueillette sélective des cerises à maturité rouge parfaite." },
        { title: "Maturation Lente", text: "Le microclimat froid concentre les sucres et affine l'acidité." },
      ],
      caption: "Parcelles d'altitude — Sierra MX",
      scaleLeft: "Échelle d'altitude",
      scaleRight: "Impact du microclimat froid",
    },
    b2b: {
      eyebrow: "Offre Coffee Shops",
      titleA: "Votre partenaire",
      titleEm: "grand volume",
      text: "Monte Yolli approvisionne les coffee shops exigeants en café de spécialité mexicain, avec la régularité d'un distributeur et l'âme d'un torréfacteur artisan.",
      items: [
        { metric: "Sur mesure", metricLabel: "Courbes de torréfaction", title: "Profils de Torréfaction Sur Mesure", desc: "Calibrage des courbes selon vos équipements et l'identité culinaire de votre établissement." },
        { metric: "100%", metricLabel: "Traçabilité directe", title: "Traçabilité Directe du Producteur", desc: "Relations équitables sans intermédiaire avec les coopératives familiales de la Sierra du Mexique." },
      ],
    },
    process: {
      eyebrow: "Processus",
      titleA: "Le voyage du grain",
      titleEm: "en 4 étapes",
      steps: [
        { num: "01", name: "Culture & Cueillette Sélective", detail: "Récolte manuelle des cerises rouges à plus de 1 800 mètres d'altitude." },
        { num: "02", name: "Traitement Artisanal", detail: "Méthodes Lavé, Honey et Naturel adaptées à chaque variété pour sublimer les arômes." },
        { num: "03", name: "Torréfaction de Précision", detail: "Torréfaction artisanale à la commande pour garantir une fraîcheur optimale." },
        { num: "04", name: "Logistique Dédiée B2B", detail: "Conditionnement sous atmosphère protectrice et livraison directe dans vos établissements." },
      ],
    },
    contact: {
      eyebrow: "Espace Distributeur",
      titleA: "Parlon",
      titleEm: "s café",
      text: "Dites-nous qui vous êtes, ce que vous servez, et recevez votre coffret découverte B2B : les 4 variétés Monte Yolli, fiches de cupping et tarifs professionnels.",
      coordsTitle: "Coordonnées directes",
      coords: { email: "Email", phone: "Téléphone", website: "Site web" },
      estimatorTitle: "Estimation de vos besoins",
      cupsLabel: "Tasses servies / jour",
      kgLabel: "de café par mois",
      name: "Nom complet du responsable *",
      business: "Coffee Shop / Établissement *",
      email: "Email professionnel *",
      phone: "Téléphone",
      volume: "Volume mensuel estimé",
      varietiesLabel: "Variétés d'intérêt",
      messageLabel: "Message / Besoins spécifiques",
      messagePlaceholder: "Parlez-nous de votre établissement, vos équipements, vos attentes…",
      phonePlaceholder: "+52 55 1234 5678",
      volumes: ["10–50 kg / mois", "50–200 kg / mois", "200 kg+ / mois"],
      sampleBox: "Je souhaite recevoir le Coffret Découverte B2B (4 variétés + fiches techniques)",
      submit: "Envoyer ma demande",
      sending: "Envoi en cours…",
      toastSuccess: "Demande envoyée",
      toastSuccessDesc: "Notre équipe vous recontacte sous 24h ouvrées.",
      successTitle: "Demande envoyée avec succès",
      successText: "Votre demande est bien enregistrée chez Monte Yolli. Notre équipe l'examine et vous recontacte sous 24h ouvrées.",
      successAgain: "Envoyer une autre demande",
      toastError: "Échec de l'envoi",
      toastErrorDesc: "Réessayez ou écrivez-nous à monteyolli@outlook.com",
    },
    footer: {
      brandDesc: "Café de la Sierra — Del Corazón de la Montaña. Distributeur de cafés de spécialité mexicains pour les coffee shops.",
      contactTitle: "Contact",
      varietiesTitle: "Variétés",
      locationTitle: "Coordonnées",
      location: "Durango Pte. 303, Col. Centro — 43600 Tulancingo de Bravo, Hgo., Mexique",
      altitude: "Altitude : 1 600 – 2 100m",
      format: "Format : Sac 400g / Sacs 60kg",
      legal: "© 2026 Monte Yolli — Tous droits réservés",
      tagline: "De la Sierra a tu Mesa",
    },
  },
  es: {
    nav: {
      varieties: "Nuestros Cafés",
      origin: "Origen Sierra",
      b2b: "Oferta Coffee Shops",
      process: "Proceso",
      contact: "Contacto",
      cta: "Caja de Muestra B2B",
      login: "Iniciar sesión",
      logout: "Cerrar sesión",
    },
    auth: {
      modalTitle: "Tu cuenta Monte Yolli",
      nameLabel: "Nombre completo",
      emailLabel: "Email",
      passwordLabel: "Contraseña (mín. 8 caracteres)",
      submitIn: "Iniciar sesión",
      submitUp: "Crear mi cuenta",
      switchToUp: "¿Aún sin cuenta? Créala",
      switchToIn: "¿Ya tienes cuenta? Inicia sesión",
      orGoogle: "Continuar con Google",
      mySpace: "Mi espacio",
      myRequests: "Mis solicitudes B2B",
      noRequests: "Aún no has enviado ninguna solicitud.",
      welcomeToast: "Bienvenido a Monte Yolli",
      errorGeneric: "Ocurrió un error. Inténtalo de nuevo.",
    },
    chat: {
      openLabel: "Asesor",
      title: "Asesor Monte Yolli",
      subtitle: "IA — FR / ES / EN",
      welcome: "¡Hola! Soy el asesor Monte Yolli. ¿Qué variedad buscas o cuántos kg necesita tu coffee shop?",
      placeholder: "Escribe tu pregunta…",
      error: "El asesor no está disponible por el momento. Inténtalo de nuevo.",
    },
    journal: {
      eyebrow: "Diario",
      titleA: "El diario de",
      titleEm: "la Sierra",
      sub: "Historias de altura, cosechas y cultura del café — escritas por nuestro equipo y nuestro asesor IA.",
      read: "Leer el artículo",
      close: "Cerrar",
    },
    estimate: {
      title: "Asistente IA — Estimación B2B",
      placeholder: "Describe tu establecimiento (ej: café de barrio, 2 máquinas espresso, 300 tazas/día)…",
      button: "Analizar mis necesidades",
      analyzing: "Analizando…",
      error: "El asistente no está disponible. Inténtalo de nuevo.",
    },
    admin: {
      link: "Espacio Admin",
      title: "Espacio Admin",
      tabRequests: "Solicitudes B2B",
      tabArticles: "Generador de artículos",
      topicPlaceholder: "Tema del artículo (ej: la cosecha 2026 en la Sierra)…",
      generate: "Generar el artículo",
      generating: "Redactando…",
      published: "Artículo publicado en el sitio",
      deleteLabel: "Eliminar",
      noArticles: "Aún no hay artículos.",
      restricted: "Acceso reservado al administrador.",
      notLoggedIn: "Inicia sesión con la cuenta de administrador.",
      backHome: "Volver al sitio",
      emptyRequests: "Aún no se han recibido solicitudes.",
      colDate: "Fecha",
      colBusiness: "Establecimiento",
      colContact: "Contacto",
      colVolume: "Volumen",
      colVarieties: "Variedades",
      colMessage: "Mensaje",
      colSample: "Caja",
      tabConfig: "Configuración",
      saveLabel: "Guardar",
      settingsSaved: "Parámetros guardados",
      contactEmailLabel: "Email de contacto del sitio",
      contactPhoneLabel: "Teléfono del sitio",
      contactWebsiteLabel: "Sitio web mostrado",
      notifEmailLabel: "Email para recibir pedidos",
      refresh: "Actualizar",
      loadError: "No se pudieron cargar las solicitudes. Toca Actualizar.",
      labelBtn: "Etiqueta",
      printLabel: "Imprimir la etiqueta de envío",
      fromLabel: "Remitente",
      toLabel: "Destinatario",
      resetBox: "Reiniciar la bandeja",
      resetConfirm: "¿Eliminar definitivamente TODAS las solicitudes de la bandeja de pedidos? Esta acción es irreversible.",
      resetDone: "Bandeja de pedidos reiniciada",
      deleteRequest: "Eliminar esta solicitud",
      deleteConfirm: "¿Eliminar esta solicitud?",
      requestDeleted: "Solicitud eliminada",
      diagLine: "Base « {db} » · {n} solicitud(es) guardada(s) · última: {last}",
      diagNone: "ninguna",
      liveHint: "Los pedidos enviados en el sitio en línea aparecen únicamente en el admin del sitio en línea (base separada de la vista previa).",
      maintenanceLabel: "Sitio en espera (página « Próximamente »)",
      maintenanceHelp: "Marcado: los visitantes ven una elegante página de espera con sus datos de contacto. Desmarcado: el sitio completo es visible. El admin siempre sigue accesible en /admin.",
      maintenanceOn: "Actualmente: sitio en espera — los visitantes ven la página « Próximamente »",
      maintenanceOff: "Actualmente: sitio completo visible para todos",
    },
    maintenance: {
      badge: "Del Corazón de la Montaña — 1 850 m",
      title: "Nuestro nuevo sitio llega",
      titleEm: "muy pronto.",
      text: "Monte Yolli prepara su nueva vitrina en línea. Para cualquier pedido de café de especialidad — Geisha, Gourmet, Lavado, Honey — o una caja de muestras para coffee shops, contáctenos directamente.",
    },
    fields: {
      address: "Dirección completa (número y calle)",
      city: "Ciudad",
      postal: "Código postal",
      country: "País",
    },
    hero: {
      badge: "Del Corazón de la Montaña — 1 850m",
      line1: "CAFÉ DE LA",
      line2Em: "SIERRA",
      line2Post: "MEXICANA",
      line3: "DEL CORAZÓN DE LA MONTAÑA",
      sub: "Monte Yolli cultiva cuatro variedades de excepción — Geisha, Gourmet, Lavado y Honey — en las alturas de la Sierra mexicana. De la Sierra a tu mesa, y de las montañas a tu barra.",
      ctaVarieties: "Descubrir nuestros cafés",
      ctaB2b: "Espacio Distribuidor B2B",
      location: "Tulancingo, Hidalgo — México",
      altitudeLabel: "Altitud de cultivo — Sierra MX",
      chip: "Saco 400g — Micro Lote",
    },
    marquee: [
      "Café de la Sierra",
      "Del Corazón de la Montaña",
      "1 850m de Altitud",
      "Geisha",
      "Gourmet",
      "Lavado",
      "Honey",
      "Micro Lote — Saco 400g",
      "Distribución para Coffee Shops",
      "De la Sierra a tu Mesa",
    ],
    products: {
      eyebrow: "Nuestros Productos",
      titleA: "El saco Monte Yolli,",
      titleEm: "cuatro firmas",
      sub: "Cada variedad se cultiva en altura, se procesa según su método ideal y se tuesta al momento para revelar su firma aromática.",
      spotEyebrow: "El Producto",
      spotTitle: "Saco Monte Yolli",
      spotDesc: "La etiqueta con los colores del arte popular mexicano guarda un café de origen en micro-lote: tostado y molido al momento, listo para tu cafetera o para tu máquina espresso profesional.",
      specs: [
        ["Contenido neto", "400g"],
        ["Tipo", "Café de Origen — Micro Lote"],
        ["Tueste", "Tostado y Molido, al momento"],
        ["Origen", "Hecho en Tulancingo, México"],
      ],
      ctaDevis: "Pedir cotización",
      lineupEyebrow: "Distribución",
      lineupTitle: "Formato 400g — cajas de 10 unidades",
      labels: { altitude: "Altitud", process: "Proceso", roast: "Tueste" },
    },
    varieties: [
      {
        id: "geisha",
        name: "GEISHA",
        tag: "La Excelencia Rara",
        altitude: "1 950m",
        process: "Honey Superior",
        notes: ["Jazmín", "Bergamota", "Durazno Blanco", "Miel Silvestre"],
        roast: "Claro / Filtro & Slow Coffee",
        score: "89.5 SCA",
        description: "Un perfil floral aéreo y complejo con notas raras de flor de azahar y miel de montaña, reservado a los establecimientos de excepción.",
      },
      {
        id: "gourmet",
        name: "GOURMET",
        tag: "El Gran Clásico Estructurado",
        altitude: "1 750m",
        process: "Lavado Tradicional",
        notes: ["Chocolate Oscuro 72%", "Avellana Tostada", "Cacao Puro", "Caramelo Caliente"],
        roast: "Medio / Espresso & Cappuccino",
        score: "86.5 SCA",
        description: "Un cuerpo redondo, aterciopelado y goloso. El equilibrio perfecto para bebidas con leche y espressos intensos.",
      },
      {
        id: "lavado",
        name: "LAVADO",
        tag: "La Pureza Mineral",
        altitude: "1 800m",
        process: "Doble Lavado con Agua de Manantial",
        notes: ["Cítricos Suaves", "Manzana Verde", "Caña de Azúcar", "Té Negro"],
        roast: "Medio-Claro / Espresso Versátil",
        score: "87.0 SCA",
        description: "Una acidez viva y cristalina producto de un lavado meticuloso con agua pura de los manantiales de la Sierra.",
      },
      {
        id: "honey",
        name: "HONEY",
        tag: "La Cremosidad Afrutada",
        altitude: "1 850m",
        process: "Yellow Honey Sensation",
        notes: ["Papaya", "Ciruela Seca", "Azúcar Mascabado", "Vainilla de Papantla"],
        roast: "Medio / Versátil Espresso & Filtro",
        score: "88.0 SCA",
        description: "Secado con su pulpa natural bajo el sol mexicano, ofreciendo una dulzura incomparable y una textura melosa.",
      },
    ],
    origin: {
      eyebrow: "Origen — Sierra Madre",
      titleA: "La montaña escribe",
      titleEm: "el sabor",
      text: "En el corazón de las montañas de México, nuestras parcelas se aferran a las laderas de la Sierra, entre 1 600 y 2 100 metros de altitud. Allá arriba, el grano madura lentamente, bajo la neblina, y gana una densidad aromática que ninguna llanura puede imitar.",
      factors: [
        { title: "Sombra Natural", text: "Los cafetales crecen bajo el dosel brumoso del bosque de altura." },
        { title: "Suelo Volcánico", text: "Un terroir mineral rico que forja la complejidad de cada grano." },
        { title: "Cosecha 100% Manual", text: "Recolección selectiva de las cerezas en su punto rojo perfecto." },
        { title: "Maduración Lenta", text: "El microclima frío concentra los azúcares y afina la acidez." },
      ],
      caption: "Parcelas de altura — Sierra MX",
      scaleLeft: "Escala de altitud",
      scaleRight: "Impacto del microclima frío",
    },
    b2b: {
      eyebrow: "Oferta Coffee Shops",
      titleA: "Su socio de",
      titleEm: "gran volumen",
      text: "Monte Yolli abastece a los coffee shops más exigentes con café de especialidad mexicano, con la regularidad de un distribuidor y el alma de un tostador artesanal.",
      items: [
        { metric: "A medida", metricLabel: "Curvas de tueste", title: "Perfiles de Tueste a Medida", desc: "Calibrado de las curvas según tus equipos y la identidad culinaria de tu establecimiento." },
        { metric: "100%", metricLabel: "Trazabilidad directa", title: "Trazabilidad Directa del Productor", desc: "Relaciones justas sin intermediarios con las cooperativas familiares de la Sierra de México." },
      ],
    },
    process: {
      eyebrow: "Proceso",
      titleA: "El viaje del grano",
      titleEm: "en 4 pasos",
      steps: [
        { num: "01", name: "Cultivo y Cosecha Selectiva", detail: "Cosecha manual de cerezas rojas a más de 1 800 metros de altitud." },
        { num: "02", name: "Procesamiento Artesanal", detail: "Métodos Lavado, Honey y Natural adaptados a cada variedad para realzar los aromas." },
        { num: "03", name: "Tueste de Precisión", detail: "Tueste artesanal bajo pedido para garantizar una frescura óptima." },
        { num: "04", name: "Logística Dedicada B2B", detail: "Empaque con atmósfera protectora y entrega directa en tus establecimientos." },
      ],
    },
    contact: {
      eyebrow: "Espacio Distribuidor",
      titleA: "Hablemos",
      titleEm: " de café",
      text: "Cuéntanos quién eres, qué sirves, y recibe tu caja de descubrimiento B2B: las 4 variedades Monte Yolli, fichas de cata y tarifas profesionales.",
      coordsTitle: "Contacto directo",
      coords: { email: "Email", phone: "Teléfono", website: "Sitio web" },
      estimatorTitle: "Estimación de tus necesidades",
      cupsLabel: "Tazas servidas / día",
      kgLabel: "de café al mes",
      name: "Nombre completo del responsable *",
      business: "Coffee Shop / Establecimiento *",
      email: "Email profesional *",
      phone: "Teléfono",
      volume: "Volumen mensual estimado",
      varietiesLabel: "Variedades de interés",
      messageLabel: "Mensaje / Necesidades específicas",
      messagePlaceholder: "Cuéntanos sobre tu establecimiento, tus equipos, tus expectativas…",
      phonePlaceholder: "+52 55 1234 5678",
      volumes: ["10–50 kg / mes", "50–200 kg / mes", "200 kg+ / mes"],
      sampleBox: "Quiero recibir la Caja de Descubrimiento B2B (4 variedades + fichas técnicas)",
      submit: "Enviar mi solicitud",
      sending: "Enviando…",
      toastSuccess: "Solicitud enviada",
      toastSuccessDesc: "Nuestro equipo te contactará en 24h hábiles.",
      successTitle: "Solicitud enviada con éxito",
      successText: "Tu solicitud quedó registrada en Monte Yolli. Nuestro equipo la revisará y te contactará en 24h hábiles.",
      successAgain: "Enviar otra solicitud",
      toastError: "Error de envío",
      toastErrorDesc: "Inténtalo de nuevo o escríbenos a monteyolli@outlook.com",
    },
    footer: {
      brandDesc: "Café de la Sierra — Del Corazón de la Montaña. Distribuidor de cafés de especialidad mexicanos para coffee shops.",
      contactTitle: "Contacto",
      varietiesTitle: "Variedades",
      locationTitle: "Ubicación",
      location: "Durango Pte. 303, Col. Centro — 43600 Tulancingo de Bravo, Hgo., México",
      altitude: "Altitud : 1 600 – 2 100m",
      format: "Formato : Saco 400g / Sacos 60kg",
      legal: "© 2026 Monte Yolli — Todos los derechos reservados",
      tagline: "De la Sierra a tu Mesa",
    },
  },
  en: {
    nav: {
      varieties: "Our Coffees",
      origin: "Sierra Origin",
      b2b: "Coffee Shop Offer",
      process: "Process",
      contact: "Contact",
      cta: "B2B Sample Box",
      login: "Sign in",
      logout: "Sign out",
    },
    auth: {
      modalTitle: "Your Monte Yolli account",
      nameLabel: "Full name",
      emailLabel: "Email",
      passwordLabel: "Password (min. 8 characters)",
      submitIn: "Sign in",
      submitUp: "Create my account",
      switchToUp: "No account yet? Create one",
      switchToIn: "Already registered? Sign in",
      orGoogle: "Continue with Google",
      mySpace: "My space",
      myRequests: "My B2B requests",
      noRequests: "No requests sent yet.",
      welcomeToast: "Welcome to Monte Yolli",
      errorGeneric: "Something went wrong. Please try again.",
    },
    chat: {
      openLabel: "Advisor",
      title: "Monte Yolli Advisor",
      subtitle: "AI — FR / ES / EN",
      welcome: "Hello! I'm the Monte Yolli advisor. Which variety are you looking for, or how many kg does your coffee shop need?",
      placeholder: "Type your question…",
      error: "The advisor is temporarily unavailable. Please try again.",
    },
    journal: {
      eyebrow: "Journal",
      titleA: "The Sierra",
      titleEm: "Journal",
      sub: "Stories of altitude, harvests and coffee culture — written by our team and our AI advisor.",
      read: "Read the article",
      close: "Close",
    },
    estimate: {
      title: "AI Assistant — B2B Estimate",
      placeholder: "Describe your establishment (e.g., neighborhood café, 2 espresso machines, 300 cups/day)…",
      button: "Analyze my needs",
      analyzing: "Analyzing…",
      error: "The assistant is unavailable. Please try again.",
    },
    admin: {
      link: "Admin Space",
      title: "Admin Space",
      tabRequests: "B2B Requests",
      tabArticles: "Article Generator",
      topicPlaceholder: "Article topic (e.g., the 2026 harvest in the Sierra)…",
      generate: "Generate article",
      generating: "Writing…",
      published: "Article published on the site",
      deleteLabel: "Delete",
      noArticles: "No articles yet.",
      restricted: "Access restricted to the administrator.",
      notLoggedIn: "Sign in with the administrator account.",
      backHome: "Back to the site",
      emptyRequests: "No requests received yet.",
      colDate: "Date",
      colBusiness: "Business",
      colContact: "Contact",
      colVolume: "Volume",
      colVarieties: "Varieties",
      colMessage: "Message",
      colSample: "Sample box",
      tabConfig: "Settings",
      saveLabel: "Save",
      settingsSaved: "Settings saved",
      contactEmailLabel: "Site contact email",
      contactPhoneLabel: "Site phone",
      contactWebsiteLabel: "Displayed website",
      notifEmailLabel: "Order notification email",
      refresh: "Refresh",
      loadError: "Could not load requests. Press Refresh.",
      labelBtn: "Label",
      printLabel: "Print shipping label",
      fromLabel: "Sender",
      toLabel: "Recipient",
      resetBox: "Reset order box",
      resetConfirm: "Permanently delete ALL requests from the order box? This cannot be undone.",
      resetDone: "Order box reset",
      deleteRequest: "Delete this request",
      deleteConfirm: "Delete this request?",
      requestDeleted: "Request deleted",
      diagLine: "Database « {db} » · {n} request(s) stored · latest: {last}",
      diagNone: "none",
      liveHint: "Orders submitted on the live site only appear in the live site's admin (separate database from the preview).",
      maintenanceLabel: "Site on hold (“Coming soon” page)",
      maintenanceHelp: "Checked: visitors see an elegant holding page with your contact details. Unchecked: the full site is visible. The admin always stays reachable at /admin.",
      maintenanceOn: "Currently: site on hold — visitors see the “Coming soon” page",
      maintenanceOff: "Currently: full site visible to everyone",
    },
    maintenance: {
      badge: "Del Corazón de la Montaña — 1,850 m",
      title: "Our new website is coming",
      titleEm: "soon.",
      text: "Monte Yolli is preparing its new online showcase. For any specialty coffee order — Geisha, Gourmet, Lavado, Honey — or a coffee-shop sample box, contact us directly.",
    },
    fields: {
      address: "Full address (street number and name)",
      city: "City",
      postal: "Postal code",
      country: "Country",
    },
    hero: {
      badge: "Del Corazón de la Montaña — 1,850m",
      line1: "COFFEE FROM THE",
      line2Em: "MEXICAN",
      line2Post: "SIERRA",
      line3: "FROM THE HEART OF THE MOUNTAIN",
      sub: "Monte Yolli grows four exceptional varieties — Geisha, Gourmet, Lavado and Honey — at high altitude in the Mexican Sierra. From the Sierra to your table, and from the mountains to your counter.",
      ctaVarieties: "Discover our coffees",
      ctaB2b: "B2B Distributor Space",
      location: "Tulancingo, Hidalgo — Mexico",
      altitudeLabel: "Growing altitude — Sierra MX",
      chip: "400g Bag — Micro Lot",
    },
    marquee: [
      "Sierra Coffee",
      "From the Heart of the Mountain",
      "1,850m Altitude",
      "Geisha",
      "Gourmet",
      "Lavado",
      "Honey",
      "Micro Lot — 400g Bag",
      "Coffee Shop Distribution",
      "From the Sierra to Your Table",
    ],
    products: {
      eyebrow: "Our Products",
      titleA: "The Monte Yolli bag,",
      titleEm: "four signatures",
      sub: "Each variety is grown at high altitude, processed with its ideal method and roasted to order to reveal its aromatic signature.",
      spotEyebrow: "The Product",
      spotTitle: "Monte Yolli Bag",
      spotDesc: "The label in the colors of Mexican folk art holds a single-origin micro-lot coffee: roasted and ground to order, ready for your home brewer or your professional espresso machine.",
      specs: [
        ["Net content", "400g"],
        ["Type", "Café de Origen — Micro Lote"],
        ["Roast", "Roasted & ground to order"],
        ["Origin", "Made in Tulancingo, Mexico"],
      ],
      ctaDevis: "Request a quote",
      lineupEyebrow: "Distribution",
      lineupTitle: "400g format — cases of 10 units",
      labels: { altitude: "Altitude", process: "Process", roast: "Roast" },
    },
    varieties: [
      {
        id: "geisha",
        name: "GEISHA",
        tag: "Rare Excellence",
        altitude: "1,950m",
        process: "Superior Honey",
        notes: ["Jasmine", "Bergamot", "White Peach", "Wild Honey"],
        roast: "Light / Filter & Slow Coffee",
        score: "89.5 SCA",
        description: "An airy, complex floral profile with rare notes of orange blossom and mountain honey, reserved for exceptional establishments.",
      },
      {
        id: "gourmet",
        name: "GOURMET",
        tag: "The Structured Grand Classic",
        altitude: "1,750m",
        process: "Traditional Washed",
        notes: ["72% Dark Chocolate", "Roasted Hazelnut", "Raw Cacao", "Warm Caramel"],
        roast: "Medium / Espresso & Cappuccino",
        score: "86.5 SCA",
        description: "A round, velvety, indulgent body. The perfect balance for milk-based drinks and intense espressos.",
      },
      {
        id: "lavado",
        name: "LAVADO",
        tag: "Mineral Purity",
        altitude: "1,800m",
        process: "Double Washed with Spring Water",
        notes: ["Soft Citrus", "Green Apple", "Sugar Cane", "Black Tea"],
        roast: "Medium-Light / Versatile Espresso",
        score: "87.0 SCA",
        description: "A bright, crystalline acidity from meticulous washing with pure Sierra spring water.",
      },
      {
        id: "honey",
        name: "HONEY",
        tag: "Fruity Smoothness",
        altitude: "1,850m",
        process: "Yellow Honey Sensation",
        notes: ["Papaya", "Dried Plum", "Muscovado Sugar", "Papantla Vanilla"],
        roast: "Medium / Versatile Espresso & Filter",
        score: "88.0 SCA",
        description: "Dried with its natural pulp under the Mexican sun, delivering an incomparable sweetness and a syrupy texture.",
      },
    ],
    origin: {
      eyebrow: "Origin — Sierra Madre",
      titleA: "The mountain writes",
      titleEm: "the taste",
      text: "In the heart of Mexico's mountains, our plots cling to the Sierra slopes, between 1,600 and 2,100 meters above sea level. Up there, the bean ripens slowly under the mist, gaining an aromatic density no lowland can imitate.",
      factors: [
        { title: "Natural Shade", text: "Coffee trees grow under the misty canopy of the high-altitude forest." },
        { title: "Volcanic Soil", text: "A rich mineral terroir that forges the complexity of every bean." },
        { title: "100% Hand-Picked", text: "Selective picking of cherries at perfect red ripeness." },
        { title: "Slow Ripening", text: "The cold microclimate concentrates sugars and refines acidity." },
      ],
      caption: "High-altitude plots — Sierra MX",
      scaleLeft: "Altitude scale",
      scaleRight: "Cold microclimate impact",
    },
    b2b: {
      eyebrow: "Coffee Shop Offer",
      titleA: "Your",
      titleEm: "high-volume partner",
      text: "Monte Yolli supplies demanding coffee shops with Mexican specialty coffee, with the reliability of a distributor and the soul of an artisan roaster.",
      items: [
        { metric: "Custom", metricLabel: "Roast curves", title: "Custom Roast Profiles", desc: "Roast curves calibrated to your equipment and your establishment's culinary identity." },
        { metric: "100%", metricLabel: "Direct traceability", title: "Direct Producer Traceability", desc: "Fair, middleman-free relationships with family cooperatives of the Mexican Sierra." },
      ],
    },
    process: {
      eyebrow: "Process",
      titleA: "The bean's journey",
      titleEm: "in 4 steps",
      steps: [
        { num: "01", name: "Farming & Selective Picking", detail: "Hand-picking red cherries above 1,800 meters of altitude." },
        { num: "02", name: "Artisanal Processing", detail: "Washed, Honey and Natural methods tailored to each variety to elevate the aromas." },
        { num: "03", name: "Precision Roasting", detail: "Artisanal roasting to order for optimal freshness." },
        { num: "04", name: "Dedicated B2B Logistics", detail: "Protective-atmosphere packaging and direct delivery to your establishments." },
      ],
    },
    contact: {
      eyebrow: "Distributor Space",
      titleA: "Let's talk",
      titleEm: " coffee",
      text: "Tell us who you are and what you serve, and receive your B2B discovery box: the 4 Monte Yolli varieties, cupping sheets and professional pricing.",
      coordsTitle: "Direct contact",
      coords: { email: "Email", phone: "Phone", website: "Website" },
      estimatorTitle: "Estimate your needs",
      cupsLabel: "Cups served / day",
      kgLabel: "of coffee per month",
      name: "Full name of the manager *",
      business: "Coffee Shop / Establishment *",
      email: "Professional email *",
      phone: "Phone",
      volume: "Estimated monthly volume",
      varietiesLabel: "Varieties of interest",
      messageLabel: "Message / Specific needs",
      messagePlaceholder: "Tell us about your establishment, your equipment, your expectations…",
      phonePlaceholder: "+52 55 1234 5678",
      volumes: ["10–50 kg / month", "50–200 kg / month", "200 kg+ / month"],
      sampleBox: "I'd like to receive the B2B Discovery Box (4 varieties + technical sheets)",
      submit: "Send my request",
      sending: "Sending…",
      toastSuccess: "Request sent",
      toastSuccessDesc: "Our team will get back to you within 24 business hours.",
      successTitle: "Request sent successfully",
      successText: "Your request has been saved with Monte Yolli. Our team will review it and contact you within 24 business hours.",
      successAgain: "Send another request",
      toastError: "Send failed",
      toastErrorDesc: "Try again or write to us at monteyolli@outlook.com",
    },
    footer: {
      brandDesc: "Sierra Coffee — From the Heart of the Mountain. Distributor of Mexican specialty coffees for coffee shops.",
      contactTitle: "Contact",
      varietiesTitle: "Varieties",
      locationTitle: "Location",
      location: "Durango Pte. 303, Col. Centro — 43600 Tulancingo de Bravo, Hgo., Mexico",
      altitude: "Altitude: 1,600 – 2,100m",
      format: "Format: 400g bag / 60kg bags",
      legal: "© 2026 Monte Yolli — All rights reserved",
      tagline: "De la Sierra a tu Mesa",
    },
  },
};
